export default __webpack_public_path__ + "assets/locales/pt/calculationsParams.json";